<template>
    <div class="app-layout">
        <nav-bar></nav-bar>
        <!--<side-bar></side-bar>-->
        <div class="main-container">
            <app-main></app-main>
        </div>
      <foo-ter></foo-ter>
    </div>
</template>

<script>
import NavBar from "./components/NavBar/NavBar";
// import SideBar from "./components/SideBar/SideBar"; :style="{height: Height + 'px'}"
import AppMain from "./components/AppMain/AppMain";
import fooTer from "./components/footer/footer";
export default {
    components: {
        NavBar,
        fooTer,
        AppMain
    },
    data () {
        return {
            Height: null
        }
    },
    mounted(){
        // - 70 是 减去导航高度（写死的）
        this.Height = document.body.clientHeight - 70;
        window.onresize = () => {
            this.Height = document.body.clientHeight - 70;
        }
    }
}
</script>

<style>
    /* Layout.vue 样式 */
    @import url('./css/layout.css');
    /* Layout.vue End */
</style>
